(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["rev6-purchase"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('rev6-purchase')) {
customElements.define('rev6-purchase', class extends HTMLElement {
connectedCallback() {
if (this.initialized) return;
this.initialized = true;
this.addEventListener('change', event => { if (event.target.matches('input[name="id"]')) this.update(); });
this.querySelector('form')?.addEventListener('submit', event => {
const selected = this.querySelector('input[name="id"]:checked');
if (!selected || selected.dataset.available !== 'true' || !this.querySelector('[data-submit]')) event.preventDefault();
});
this.update();
}
update() {
const selected = this.querySelector('input[name="id"]:checked');
if (!selected) return;
this.querySelector('[data-price]').textContent = selected.dataset.price;
const reference = this.querySelector('[data-reference-price]');
reference.textContent = selected.dataset.referencePrice || '';
reference.hidden = !selected.dataset.referencePrice;
const button = this.querySelector('[data-submit]');
if (button) {
button.disabled = selected.dataset.available !== 'true';
button.textContent = button.disabled ? button.dataset.soldOut : button.dataset.label;
}
}
});
}
  } catch(e) { console.error(e); }
})();

})();
